import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

/**
 * Global UI flags that survive a page reload. Keep this small — only state
 * that is genuinely cross-cutting (i.e. read from more than one feature) and
 * persists across routes belongs here. Feature-local UI state stays in the
 * feature.
 */
export interface UiState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      toggleSidebar: () =>
        set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
    }),
    {
      name: 'trulyinbox-ui',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
